import { useEffect, useRef } from 'react';
import { notifications } from '@mantine/notifications';

/**
 * Shows a toast + vibration when Kian finishes answering while the flyout is closed.
 */
export function useKianAnswerNotification(isLoading: boolean, flyoutOpen: boolean) {
  const prevLoading = useRef(false);

  useEffect(() => {
    if (prevLoading.current && !isLoading && !flyoutOpen) {
      notifications.show({
        message: 'Kian hat geantwortet',
        color: 'orange',
        autoClose: 4000,
      });
      navigator.vibrate?.([150]);
    }
    prevLoading.current = isLoading;
  }, [isLoading, flyoutOpen]);
}
